export const createMockedURL = (resource, params) => `begin:${resource.URLFactory(params)}`;
